import { MetadataContext } from "@jumbo/components/JumboMetadataProvider/JumboMetadataProvider";
import React from "react";

const useMetadata = () => {
  return React.useContext(MetadataContext)
};

export default useMetadata;
